import * as angular from 'angular';
import { ReferralAccountsService } from '../../referralAccounts.service';
import { StoreListItem, ReferralAccountListItem } from '../../../core';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';

class ReferralAccountComponent {
    static $inject = ['$scope', '$timeout', 'referralAccountsService', 'notificationService'];
    modalInstance: ng.ui.bootstrap.IModalServiceInstance = <any>this;
    resolve: {
        stores: StoreListItem[],
    };
    waiting: boolean;
    data = {
        shopper: <ReferralAccountListItem>null,
        referralCode: '',
        storeID: <number>null
    };
    error = <string>null;

    constructor(
        private $scope: ng.IScope,
        private $timeout: ng.ITimeoutService,
        private referralAccountsService: ReferralAccountsService,
        private notificationService: NotificationService
    ) {
        this.init();
    }

    save = async () => {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            await this.referralAccountsService.add({
                ShopperID: this.data.shopper.ID,
                StoreID: this.data.storeID
            });
            this.notificationService.showSuccessMessage();
            this.modalInstance.close();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
    }

    cancel = () => {
        this.modalInstance.dismiss({ $value: 'cancel' });
    }

    private init = async () => {
        await this.$timeout(0);
        this.$scope.$watch('$ctrl.data.referralCode', async (n: string, o: string) => {
            if (!n || n === o) {
                return;
            }
            try {
                this.data.shopper = await this.referralAccountsService.searchByReferralCode(n);
                this.error = null;
            } catch (error) {
                this.error = error;
            }

        });
    }
}

angular.module('naut').component('referralAccount', {
    template: require('./referralAccount.html'),
    controller: ReferralAccountComponent,
    controllerAs: '$ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/referral-accounts/components/referralAccount/referralAccount.component.ts